@if (error) {
    <div class="ap-input__error" data-testid="error">
        <span class="ap-sr-only">{{ 'fieldErrors.error' | apContent }}</span>
        {{ error }}
    </div>
}
